module.exports = __webpack_public_path__ + "img/p3.6924947e.png";